if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));

      // =================================================================
      // ACTIVE: Mindestbestellwert (Minimum Order Value) + Free Shipping
      // - Below 35 EUR: Show minimum order message
      // - From 100 EUR: Show free shipping progress
      // - Above threshold: Show free shipping success
      // =================================================================

      const MINIMUM_ORDER = 3500;  // 35 EUR in cents
      const SHOW_FREE_SHIPPING_FROM = 10000; // 100 EUR in cents

      // Case 1: Below minimum order value (< 35 EUR) - Show only Mindestbestellwert
      if (cartTotal < MINIMUM_ORDER) {
        const remaining = MINIMUM_ORDER - cartTotal;
        const remainingFormatted = this._formatMoneySimple(remaining);
        this.innerHTML = `
          <p class="text-size--small" style="margin: 0 0 0.5rem; padding: 0.75rem; background: var(--color-third-background-main); border-radius: var(--border-radius-forms);">
            Der Mindestbestellwert von 35 € wurde noch nicht erreicht. Es fehlen noch <strong>${remainingFormatted}</strong>
          </p>
        `;
        return;
      }

      // Case 2: Minimum reached, show Versandkostenfrei message (>= 35 EUR)
      if (freeShippingRemaining < 0) {
        const remainingFormatted = this._formatMoneySimple(Math.abs(freeShippingRemaining));
        this.innerHTML = `
          <p class="text-size--small" style="margin: 0 0 0.5rem; padding: 0.75rem; background: var(--color-third-background-main); border-radius: var(--border-radius-forms);">
            Noch <strong>${remainingFormatted}</strong> bis zur kostenlosen Lieferung!
          </p>
        `;
        return;
      }

      // Case 3: Free shipping achieved
      this.innerHTML = `
        <p class="text-size--small" style="margin: 0 0 0.5rem; padding: 0.75rem; background: var(--color-third-background-main); border-radius: var(--border-radius-forms); color: var(--color-accent-main);">
          Glückwunsch! Du hast kostenlose Lieferung freigeschaltet!
        </p>
      `;

      /*
       * =================================================================
       * OPTION: Default theme behavior (Free shipping message only)
       * To enable: Uncomment this block and comment out the above
       * =================================================================
       *
       * let shippingMessage = '';
       * let shippingSuccess = false;
       *
       * if ( freeShippingRemaining < 0 ) {
       *   shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));
       * } else {
       *   shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
       *   shippingSuccess = true;
       * }
       *
       * if ( this.hasAttribute('data-show-alert') ) {
       *   this.innerHTML = `
       *     <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
       *       ${shippingMessage}
       *     </div>`;
       * } else {
       *   this.innerHTML = shippingMessage;
       * }
       *
       * =================================================================
       */

    }

    /*
     * Simple money formatter
     * Format: "28,96 €"
     */
    _formatMoneySimple(cents) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      if (isNaN(cents) || cents === null) {
        return '0,00 €';
      }
      const euros = (cents / 100.0).toFixed(2);
      const parts = euros.split('.');
      const integerPart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
      const decimalPart = parts[1];
      return integerPart + ',' + decimalPart + ' €';
    }

    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}

			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';

				if (isNaN(number) || number === null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';

				return dollarsAmount + centsAmount;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);

		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
